import Vue from 'vue';
//import ReturnRequest from './ReturnRequest';
//import ReturnRequestList from './ReturnRequestList';

const EventBus = new Vue();

export default EventBus; 


// WEBPACK FOOTER //
// ./src/components/api/v1/store/service_requests/event-bus.js